import axios from "@app/Security/AxiosAuthentication";
import htmlParser from "@app/utils/htmlParser";
import UserRoleTypesInterface from "@app/Interface/UserRoleTypesInterface";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class UserRoleTypesHelper {

    /**
     * Get a list of Front End User Role Types from WordPress
     *
     * @param controller AbortController - handles if component unmounts or if cancel button is added 
     * @returns 
     */
    static getRoleTypes = async (controller: AbortController): Promise<UserRoleTypesInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const url = baseUrl + ApiEndpoints.FE_USER_ROLE;

        return await axios.get(url, {
            withCredentials: true,
            signal: controller.signal
        })
            .then(response => {

                const dataItems: UserRoleTypesInterface[] = response.data["hydra:member"];

                const roleTypes = UserRoleTypesHelper.getRoleTypesFromResponseData(dataItems);

                return roleTypes;

            })
            .catch(error => {

                RollbarHelper.logRequestError(error, "getRoleTypes()");
                
                // return an empty set of navItems
                const emptyItems: Array<UserRoleTypesInterface> = [];

                return emptyItems;

            });

    }

    /**
     * Transforms/udates data fields, such as htmlDecode on strings 
     * 
     * @param dataItems 
     * @returns 
     */
    static getRoleTypesFromResponseData = (dataItems: UserRoleTypesInterface[]): UserRoleTypesInterface[] => {

        dataItems.forEach(roletype => {

            if (typeof roletype.title === "string") {
                roletype.title = htmlParser.htmlDecode(roletype.title);
            }

            if (typeof roletype.description === "string") {
                roletype.description = htmlParser.htmlDecode(roletype.description);
            }

        });

        return dataItems;

    }

    /**
     * 
     * @param roleTypes 
     * @param roleIds 
     * @returns 
     */
    static getRoleNamesList = (roleTypes: UserRoleTypesInterface[], roleIds: number[]): string[] => {

        const arrNames: string[] = [];

        roleIds.forEach(roleId => {

            const roleType = roleTypes.find(type => type.id === roleId);

            if (roleType) {
                arrNames.push(roleType.title);
            }

        });

        return arrNames;
        
    }

}